"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrganization = instanceOfOrganization;
exports.OrganizationFromJSON = OrganizationFromJSON;
exports.OrganizationFromJSONTyped = OrganizationFromJSONTyped;
exports.OrganizationToJSON = OrganizationToJSON;
exports.OrganizationToJSONTyped = OrganizationToJSONTyped;
var Ace_1 = require("./Ace");
var League_1 = require("./League");
var OrganizationMeta_1 = require("./OrganizationMeta");
var EmbeddableSid_1 = require("./EmbeddableSid");
var OrganizationSettings_1 = require("./OrganizationSettings");
var OrganizationAttribute_1 = require("./OrganizationAttribute");
var OrganizationProfile_1 = require("./OrganizationProfile");
var PermissionLevel_1 = require("./PermissionLevel");
var OrganizationUrl_1 = require("./OrganizationUrl");
/**
 * Check if a given object implements the Organization interface.
 */
function instanceOfOrganization(value) {
    if (!('key' in value) || value['key'] === undefined)
        return false;
    return true;
}
function OrganizationFromJSON(json) {
    return OrganizationFromJSONTyped(json, false);
}
function OrganizationFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'version': json['version'] == null ? undefined : json['version'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateModified': json['dateModified'] == null ? undefined : (new Date(json['dateModified'])),
        'owner': json['owner'] == null ? undefined : (0, EmbeddableSid_1.EmbeddableSidFromJSON)(json['owner']),
        'acesInheriting': json['acesInheriting'] == null ? undefined : json['acesInheriting'],
        'name': json['name'] == null ? undefined : json['name'],
        'key': json['key'],
        'image': json['image'] == null ? undefined : json['image'],
        'rootForDomain': json['rootForDomain'] == null ? undefined : json['rootForDomain'],
        'settings': json['settings'] == null ? undefined : (0, OrganizationSettings_1.OrganizationSettingsFromJSON)(json['settings']),
        'profile': json['profile'] == null ? undefined : (0, OrganizationProfile_1.OrganizationProfileFromJSON)(json['profile']),
        'requireMfaOnLevel': json['requireMfaOnLevel'] == null ? undefined : (0, PermissionLevel_1.PermissionLevelFromJSON)(json['requireMfaOnLevel']),
        'leagues': json['leagues'] == null ? undefined : (json['leagues'].map(League_1.LeagueFromJSON)),
        'urls': json['urls'] == null ? undefined : (json['urls'].map(OrganizationUrl_1.OrganizationUrlFromJSON)),
        'aces': json['aces'] == null ? undefined : (json['aces'].map(Ace_1.AceFromJSON)),
        'meta': json['meta'] == null ? undefined : (0, OrganizationMeta_1.OrganizationMetaFromJSON)(json['meta']),
        'attributes': json['attributes'] == null ? undefined : (json['attributes'].map(OrganizationAttribute_1.OrganizationAttributeFromJSON)),
        'illegal': json['illegal'] == null ? undefined : json['illegal'],
    };
}
function OrganizationToJSON(json) {
    return OrganizationToJSONTyped(json, false);
}
function OrganizationToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'version': value['version'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateModified': value['dateModified'] == null ? undefined : ((value['dateModified']).toISOString()),
        'owner': (0, EmbeddableSid_1.EmbeddableSidToJSON)(value['owner']),
        'acesInheriting': value['acesInheriting'],
        'name': value['name'],
        'key': value['key'],
        'image': value['image'],
        'rootForDomain': value['rootForDomain'],
        'settings': (0, OrganizationSettings_1.OrganizationSettingsToJSON)(value['settings']),
        'profile': (0, OrganizationProfile_1.OrganizationProfileToJSON)(value['profile']),
        'requireMfaOnLevel': (0, PermissionLevel_1.PermissionLevelToJSON)(value['requireMfaOnLevel']),
        'leagues': value['leagues'] == null ? undefined : (value['leagues'].map(League_1.LeagueToJSON)),
        'urls': value['urls'] == null ? undefined : (value['urls'].map(OrganizationUrl_1.OrganizationUrlToJSON)),
        'aces': value['aces'] == null ? undefined : (value['aces'].map(Ace_1.AceToJSON)),
        'meta': (0, OrganizationMeta_1.OrganizationMetaToJSON)(value['meta']),
        'attributes': value['attributes'] == null ? undefined : (value['attributes'].map(OrganizationAttribute_1.OrganizationAttributeToJSON)),
        'illegal': value['illegal'],
    };
}
